var map = {
	"./captures/1.jpg": 234,
	"./themes/environment/brown.jpg": 235,
	"./themes/environment/white.jpg": 236,
	"./themes/message/horsing.jpg": 237,
	"./themes/message/spectacular.jpg": 238,
	"./themes/message/stars.jpg": 239,
	"./themes/message/wish.jpg": 240
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 233;